module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [{
      active: _vm.isActive
    }, _vm.position],
    attrs: {
      "id": "logo-loader"
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gradient"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "line1"
  }), _vm._v(" "), _c('div', {
    staticClass: "line2"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle2"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1690963a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LogoLoader.vue
// module id = 722
// module chunks = 0